export const EMPTY_LIST_TEXT = {
    description: 'Meetings list empty text',
    defaultMessage: 'There are no meetings in the event.',
    id: 'oe.meeting.emptyListText',
};

export const PRESENTERS_TEXT = {
    id: `oe.meeting.presenters`,
    description: 'Label text',
    defaultMessage: 'Presenters',
};

export const MEETING_TYPE_TEXT = {
    id: `oe.meeting.meetingType`,
    description: 'Label text',
    defaultMessage: 'Meeting Type',
};

export const TRACK_TEXT = {
    id: `oe.meeting.track`,
    description: 'Label text',
    defaultMessage: 'Track',
};
